







import Component from 'vue-class-component'
import { Vue, Watch } from 'vue-property-decorator'
import PriceConfig from '@/dto/price_config/PriceConfig'
import PriceConfigForm from '@/components/price-config/PriceConfigForm.vue'
import priceConfigStore from '@/stores/PriceConfigStore'

@Component({
  components: { PriceConfigForm },
})
export default class PriceConfigCreate extends Vue {
  model: PriceConfig | null = null
  priceConfigStore = priceConfigStore

  get title(): string {
    return `Настройка цен и весов «${(this.model as PriceConfig).pattern}»`
  }

  @Watch('priceConfigStore.priceConfig', { immediate: true })
  setModel(priceConfig: PriceConfig) {
    if (priceConfig) {
      this.model = Object.assign({}, priceConfig)
    }
  }
}
